// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SSKUcEFPfMhscfuATPUZ{font-family:AccordAltThin,Helvetica,sans-serif;display:flex}.LoTL7zxjnDZcoipgWl89{flex:1;display:flex;align-items:center;justify-content:center;font-size:18px;text-transform:uppercase;font-weight:bold}.ql__yDE7p6wAir0_32JQ{padding:0 16px;height:100%;display:flex;align-items:center;border-right:1px solid #666}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "SSKUcEFPfMhscfuATPUZ",
	"label": "LoTL7zxjnDZcoipgWl89",
	"plus": "ql__yDE7p6wAir0_32JQ"
};
export default ___CSS_LOADER_EXPORT___;
